"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

function default_1(_a) {
  var onClick = _a.onClick,
      className = _a.className,
      _b = _a.renderIcon,
      renderIcon = _b === void 0 ? function () {
    return '';
  } : _b,
      _c = _a.renderTitle,
      renderTitle = _c === void 0 ? function () {
    return '';
  } : _c,
      _d = _a.renderAction,
      renderAction = _d === void 0 ? function () {
    return '';
  } : _d,
      rest = __rest(_a, ["onClick", "className", "renderIcon", "renderTitle", "renderAction"]);

  return react_1.default.createElement("div", {
    onClick: onClick,
    className: classnames_1.default('card-header d-flex align-items-start', className, {
      'cursor-pointer': !!onClick
    })
  }, react_1.default.createElement("div", {
    className: 'position-relative'
  }, renderIcon(rest)), renderTitle(rest), react_1.default.createElement("div", {
    className: 'col'
  }), react_1.default.createElement("div", null, renderAction(rest)));
}

exports.default = default_1;